import { useGateValue } from "@statsig/react-bindings";

/**
 * Custom hook to check if Custom Field Card is enabled.
 * Returns a boolean indicating whether the "enable_custom_field_card"
 * feature gate is enabled on Statsig.
 */
export const useEnableCustomFieldCard = (): boolean => {
  return useGateValue("enable_custom_field_card");
};
